import { BaseModel } from './base';

export class TravelType extends BaseModel {
  id: string;
  travelTypeName: string;
  _id: string;
}
